module.exports = __webpack_public_path__ + "img/rsvc.e504a03a.png";